//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from '@/components/objects/IconView.vue'
import { moment } from '~/plugins/moment'

export default {
  name: 'UserProfileCommentItem',
  components: { IconView },
  props: {
    comment: {
      type: Object,
      required: true,
    },
    to: {
      type: Object,
      default: null,
    },
  },
  computed: {
    node() {
      return this.comment?.node ?? this.comment ?? {}
    },
    user() {
      return this.node.user_annotated ?? this.comment?.user_annotated ?? {}
    },
    userIcon() {
      return this.user?.profile?.icon
    },
    userName() {
      return this.user?.profile?.nickname || this.user?.username || 'Автор'
    },
    text() {
      return this.node.text ?? this.comment?.text ?? ''
    },
    isDeleted() {
      return Boolean(this.node.is_deleted ?? this.comment?.is_deleted)
    },
    formattedDate() {
      const value = this.node.created_at ?? this.comment?.created_at
      if (!value) return ''

      const date = new Date(new Date(value).getTime() - new Date(value).getTimezoneOffset() * 60000)
      return moment(date).format('HH:mm, DD.MM.YYYY')
    },
  },
}
